// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__10EA7","input":"Product_input__28qfB","button":"Product_button__1GrtL"};